import { Box, Typography } from '@mui/material';

/**
 * Shared Nivo tooltip card. Use inside a chart's `tooltip` prop.
 *
 *   tooltip={({ node }) => <ChartTooltip title={node.data.name} rows={[...]} />}
 */
export default function ChartTooltip({ title, subtitle, rows = [] }) {
    return (
        <Box
            sx={{
                bgcolor: 'custom.surface.elevated',
                p: 1.25,
                borderRadius: 1,
                border: t => '1px solid ' + t.palette.custom.border.default,
                minWidth: 160,
                boxShadow: '0 4px 12px rgba(0,0,0,0.35)',
            }}
        >
            {title && (
                <Typography
                    sx={{
                        fontWeight: 600,
                        fontSize: '0.8rem',
                        color: 'text.primary',
                        mb: subtitle ? 0 : 0.5,
                    }}
                >
                    {title}
                </Typography>
            )}
            {subtitle && (
                <Typography sx={{ fontSize: '0.7rem', color: 'text.muted', mb: 0.5 }}>
                    {subtitle}
                </Typography>
            )}
            {rows.map((r, i) => (
                <Box
                    key={i}
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: 2,
                        fontSize: '0.75rem',
                        lineHeight: 1.5,
                    }}
                >
                    <Box
                        sx={{
                            color: 'text.muted',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.75,
                        }}
                    >
                        {r.color && (
                            <Box
                                component="span"
                                sx={{
                                    width: 8,
                                    height: 8,
                                    borderRadius: '50%',
                                    bgcolor: r.color,
                                    display: 'inline-block',
                                }}
                            />
                        )}
                        {r.label}
                    </Box>
                    <Box
                        sx={{
                            color: r.valueColor || 'text.primary',
                            fontFamily: t => t.typography.fontFamilyMono,
                            fontWeight: 600,
                        }}
                    >
                        {r.value}
                    </Box>
                </Box>
            ))}
        </Box>
    );
}
